import { createFileRoute } from '@tanstack/react-router';
import NewOrderPage from '../components/manager/NewOrderPage';

export const Route = createFileRoute('/reception/orders/new')({
  component: ReceptionNewOrderRoute,
});

function ReceptionNewOrderRoute() {
  return <NewOrderPage />;
}
